import React from 'react';
export default function ClientTabHeading({ title, description }) {
  return <div className="min-w-0"><h2 className="client-tab-title font-sans text-xl font-bold leading-7 text-slate-900">{title}</h2><p className="mt-1 text-sm font-normal leading-5 text-slate-500">{description}</p></div>;
}
